<template>
  <div class="pc_permiss_limits">
    <!-- 搜索 -->
    <div class="pc_select">
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <el-form-item label="">
                <el-input
                clearable
                  v-model="selectForm.keyword"
                  placeholder="请输入用户名"
                  @clear="handleClear"
                  @keyup.enter.native='onSelect'
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"></el-col>
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="getTabeData"
      border
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="user_id"
        width="200"
        label="用户名"
      ></el-table-column>
      <el-table-column prop="rightstr" label="角色权限">
        <template slot-scope="scope">
          <el-tag effect="dark">{{ rightList[scope.row.rightstr] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="当前状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.defunct === 'N'">开放</el-tag>
          <el-tag type="warning" v-if="scope.row.defunct === 'Y'">屏蔽</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="220">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击修改用户状态"
            placement="top"
          >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleClick(scope.row.user_id, scope.row.rightstr)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pc_pages">
      <div class="block">
        <!-- <span class='demonstration'>完整功能</span> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="sizes"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import { initPrivilegeList,initRightList,deleteLimits } from 'api/post/postApi.js';

export default {
  name: 'pc_cat_two',
  components: {},
  data() {
    return {
      loading: true,
      tableData: [],
      rightList: {},
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      selectForm: { keyword: '' }
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  mounted() {
    this.initRight();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initPrivilegeList();
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },
    // 获取权限数据
    async initRight() {
      const { data: res } = await initRightList();
      if (res.status === 0) {
        this.rightList = res.data;
      }
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 删除当前用户角色
    async handleClick(id, rig) {
      const confirmResult = await this.$confirm(
        '此操作将删除当前用户的角色, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = {
        user_id:id,
        rightstr:rig
      };
      const { data: res } = await deleteLimits(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
        this.initData();
      }
    },
    // 搜索实现
    async onSelect() {
      const { data: res } = await initPrivilegeList(this.selectForm);
      if (res.status !== 0) {
        this.$message.error('查找失败！');
        return;
      }
      this.$message.success('查找成功！');
      this.tableData = res.data;
      this.total = res.data.length;
    },
    // 搜索清除
    handleClear(){
      // 重新加载数据
      this.selectForm={};
      this.initData();
    }
  }
};
</script>

<style scoped>
.pc_pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.cratebtn {
  float: right;
}
</style>